import './vite-shim'
// A sessão nasce antes do roteador: é na criação que o `#session_code=` da volta
// do login social é capturado, antes de qualquer `beforeLoad` redirecionar.
import '@/shared/services/session/instance'

import { StrictMode } from 'react'

import { RouterProvider, createRouter } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'

import { routeTree } from './routeTree.gen'

import './instrumentation-client'
import { applyDevDocumentTitle } from '@/shared/lib/runtime/dev-environment'
import '../styles/tailwind.css'
import '@/shared/ui/EvnttzIcons/tokens.css'
import '@/shared/ui/QrCodeReader/styles.scss'

const router = createRouter({
  routeTree
} as Parameters<typeof createRouter>[0])

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

if (import.meta.env.DEV) {
  document.title = applyDevDocumentTitle(document.title)
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
